<section class="mt-3">
  <form #socioForm="ngForm" (ngSubmit)="saveSocio()" *ngIf="!loading">
    <div class="form-body">
      
      <h4 class="mat-h4 color-blue-cat">Datos domiciliarios</h4>
      <div class="row">
        <mat-form-field class="col-12 col-md-4">
          <mat-label>Calle</mat-label>
          <input matInput name="calle" [(ngModel)]="socio.calle">
        </mat-form-field>
  
        <mat-form-field class="col-12 col-md-2">
          <mat-label>Número</mat-label>
          <input matInput name="numero" [(ngModel)]="socio.numero">
        </mat-form-field>
  
        <div class="col-12 col-md-3">
          <div class="d-flex justify-content-between">
            <mat-form-field class="col-6 pl-0">
              <mat-label>Código Postal</mat-label>
              <input matInput (keypress)="validaNumeros($event)" name="cp" [(ngModel)]="socio.codigoPostal" maxlength="5">
            </mat-form-field>
            <button class="h-75" type="button" mat-raised-button color="primary" matTooltip="Buscar localidades por Código Postal" matTooltipPosition="above" (click)="getColonias()" [disabled]="loadingColonias">
              <mat-icon>search</mat-icon> Buscar 
            </button>
          </div>

          <div class="d-flex justify-content-center">
            <mat-spinner diameter="40" *ngIf="loadingColonias"></mat-spinner>
          </div>

        </div>

        <mat-form-field class="col-12 col-md-3">
          <mat-label>Seleccione la localidad</mat-label>
          <mat-select #localidad="ngModel" name="localidad" [(ngModel)]="socio.idCiudad" [disabled]="loadingColonias" required>
            <mat-option *ngFor="let colonia of allColonias" [value]="colonia.idCd">{{colonia.col}}</mat-option>
          </mat-select>
          <mat-error *ngIf="localidad.invalid && localidad.touched">*Campo requerido</mat-error
          >
        </mat-form-field>
      </div>
      
      <!---
      <h4 class="mat-h4 color-blue-cat">Datos de identificación</h4>
      <div class="row">
        <mat-form-field class="col-12 col-md-4">
          <mat-label>INE</mat-label>
          <input matInput (keypress)="validaNumeros($event)" name="ine" [(ngModel)]="socio.ife" maxlength="20">
        </mat-form-field>
  
        <mat-form-field class="col-12 col-md-4">
          <mat-label>NSS</mat-label>
          <input matInput (keypress)="validaNumeros($event)" name="nss" [(ngModel)]="socio.nss" placeholder="Número de Seguridad Social del IMSS" maxlength="11">
        </mat-form-field>
  
        <mat-form-field class="col-12 col-md-4">
          <mat-label>CURP</mat-label>
          <input matInput class="text-uppercase" name="curp" [(ngModel)]="socio.curp" maxlength="18">
        </mat-form-field>
      </div>
      -->
  
      <div class="form-actions">
        <div class="text-right">                      
          <button mat-raised-button type="submit" class="btn-blue-cat mr-2">Guardar</button>
          <!---<a mat-raised-button class="btn-gray-cat">Cancelar</a>--->
        </div>
      </div>
  
    </div>  
  
  </form>
  
  <!--Div a mostrar cuando estén cargando los datos-->
  <div class="alert alert-light text-center" *ngIf="loading">
    <p class="d-flex justify-content-center">
      <mat-spinner></mat-spinner>
    </p>
  </div>
</section>